import { Container, Grid } from '@material-ui/core'
import React from 'react'
import { ButtonHLPure, DialogSystemGLPure, HeaderHLPure, PromotionalFooterPure, SimpleLoading } from '../../pures';
import './repse-status.view.css';

import "swiper/swiper.min.css";
import RepseStatusCompanyView from './repse-status-company.view';
import RepseStatusContractsView from './repse-status-contracts.view';
import ContractRepseAction from '../../actions/contract-repse/contract-repse.action';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const RepseStatusView = (props) => {
    let view;
    let title;
    const { t } = useTranslation()
    const history = useHistory()

    if (props.showContractScreen) {
        return <ContractRepseAction
            contract={props.editingContract}
            proveedorRepse={props.selectedContractor}
            company={props.selectedCompany}
            selectedContractor={props.selectedContractor}
            onContractorSelected={props.onContractorSelected}
            toggleContractDetailsScreen={props.toggleContractDetailsScreen}
        />
    }

    if (props.selectedContractor) {
        title = "Estado REPSE por proveedor";
        view = <RepseStatusContractsView
            selectedContractor={props.selectedContractor}
            contracts={props.contracts}
            getColorByContractStatus={props.getColorByContractStatus}
            onContractSelected={props.onContractSelected}
            selectedContract={props.selectedContract}
            documents={props.documents}
            selectedDocument={props.selectedDocument}
            documentUrl={props.documentUrl}
            onDocumentSelected={props.onDocumentSelected}
            getColorByDocumentStatus={props.getColorByDocumentStatus}
            selectedYear={props.selectedYear}
            yearFilterOptions={props.yearFilterOptions}
            onYearFilterChange={props.onYearFilterChange}
            onBack={props.onBackContractorScreen}
            toggleContractDetailsScreen={props.toggleContractDetailsScreen}
        />
    } else {
        title = "Estado REPSE por empresa";
        view = <RepseStatusCompanyView
            selectedCompany={props.selectedCompany}
            getColorByCompanyStatus={props.getColorByCompanyStatus}
            contractors={props.contractors}
            getColorByContractorStatus={props.getColorByContractorStatus}
            onContractorSelected={props.onContractorSelected}
            selectedYear={props.selectedYear}
            yearFilterOptions={props.yearFilterOptions}
            onYearFilterChange={props.onYearFilterChange}
            companyFilterOptions={props.companyFilterOptions}
            onCompanyFilterChange={props.onCompanyFilterChange}
            email={props.email}
            createContractor={props.createContractor}
        />
    }

    return (
        <>
            {
                props.isLoading && <div className='standard-wrapper'>
                    <SimpleLoading />
                </div>
            }
            {
                !props.isLoading &&
                <>
                    <div className='standard-wrapper'>
                        <Container>
                            <HeaderHLPure title={title} />

                            <Container className='RepseStatusView-content'>
                                {view}
                            </Container>

                            <PromotionalFooterPure />
                        </Container>
                    </div>
                </>
            }
            <DialogSystemGLPure
                showLoadingRequesting={props.showLoadingRequesting}
                toggleLoadingRequesting={props.toggleLoadingRequesting}

                showCompletedRequesting={props.showCompletedRequesting}
                toggleCompletedRequesting={props.toggleCompletedRequesting}

                showWarningRequesting={props.showWarningRequesting}
                toggleWarningRequesting={props.toggleWarningRequesting}

                showErrorRequesting={props.showErrorRequesting}
                toggleErrorRequesting={props.toggleErrorRequesting}
                message={props.messageError} />
        </>
    )
}

export default RepseStatusView